import {grey400, grey800, blue600} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    items: {
        marginLeft: 0,
        primaryText: {
            marginLeft: -20,
            fontSize: 15,
            color: grey800,
            fontWeight: typography.fontWeightLight
        }
    },
    subitems: {
        marginLeft: 10,
        primaryText: {
            marginLeft: -15,
            fontSize: 15,
            color: grey800,
            fontWeight: typography.fontWeightLight
        }
    },
    block: {
        textAlign: 'center',
        paddingBottom: 20,
        fontSize: 10

    },
    avatar: {
        verticalAlign: 'middle',
        display: 'block',
        margin: 'auto',
        marginTop: 10,
        backgroundColor: blue600,
        boxShadow: '0 2px 6px rgba(0,0,0,0.32), 0 2px 4px rgba(0,0,0,0.32)'
    },
    header: {
        width: '100%',
        height: 80,
        paddingTop: 20,
        display: 'block',
        backgroundColor:blue600
    },
    title: {
        paddingTop: 30,
        color: grey800
    },
    subtitle: {
        fontSize: 12,
        color: grey400
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/application/BlockApplication/BlockApplication.css.js